export const CREATE_PROFILE_START = 'CREATE_PROFILE_START';
export const CREATE_PROFILE_FAILED = 'CREATE_PROFILE_FAILED';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
